import 'tippy.js/dist/tippy.css'

import tippy from 'tippy.js'

const createTippyInstance = (el, binding) => {
  if (!binding.value) {
    return
  }

  if (el._tippy) {
    el._tippy.setContent(binding.value)
  } else {
    el.setAttribute('data-tippy-content', binding.value)
    tippy(el, {
      arrow: true,
      interactive: true,
      allowHTML: true,
    })
  }
}

export default {
  bind: createTippyInstance,
  componentUpdated: createTippyInstance,
  unbind: el => {
    if (el._tippy) el._tippy.destroy()
  },
}
